import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Sidebar from "../profile-sidebar/profileSidebar";
import { bookingService } from "../../services/bookingService";
import {
  formatPrice,
  formattedDateTime,
  countDays,
  statusBookingClassName,
  truncateText,
} from "../../Helpers/BaseHelper";

import BookingDetailModal from "./bookingDetailModal";
import { Link } from "react-router-dom";
const CustomerTourBooking = () => {
  const { userInfo } = useSelector((state) => state.user);
  const [bookings, setBookings] = useState([]);

  const [isStatusOpen, setIsStatusOpen] = useState(false);

  const [statusText, setStatusText] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [isCancelled, setIsCancelled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const data = await bookingService.getBookingByUserIdPaging(
          userInfo.id,
          currentPage,
          pageSize,
          debouncedSearchTerm,
          statusText
        );
        setBookings(data.data); // Lưu dữ liệu vào state
        setTotalPages(data.totalPages);
      } catch (error) {
        toast.error("Không thể tải danh sách đặt chỗ.");
      }
    };

    if (userInfo) {
      fetchBookings();
    }
  }, [
    userInfo,
    currentPage,
    pageSize,
    isCancelled,
    debouncedSearchTerm,
    statusText,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {}, [selectedBooking]);

  const toggleStatusDropdown = () => {
    setIsStatusOpen(!isStatusOpen);
  };

  const handleStatusChange = (status) => {
    setStatusText(status === "Status" ? null : status);
    setIsStatusOpen(false);
  };

  return (
    <div className="content">
      {console.log(bookings, "bookings")}
      <div className="container">
        <div className="row">
          {/* <!-- Sidebar --> */}
          <Sidebar page="customer-tour-booking" />
          {/* <!-- /Sidebar --> */}

          {/* <!-- Hotel Booking --> */}
          <div className="col-xl-9 col-lg-8">
            {/* <!-- Booking Header --> */}
            <div className="card booking-header">
              <div className="card-body header-content d-flex align-items-center justify-content-between flex-wrap ">
                <div>
                  <h6>Tour</h6>
                  <p className="fs-14 text-gray-6 fw-normal ">
                    Số lượng tour đã đặt : {bookings.length}
                  </p>
                </div>
              </div>
            </div>
            {/* <!-- /Booking Header --> */}

            {/* <!-- Car-Booking List --> */}
            <div className="card hotel-list">
              <div className="card-body p-0">
                <div className="list-header d-flex align-items-center justify-content-between flex-wrap">
                  <h6 className="">Danh sách tour đã đặt</h6>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="input-icon-start  me-2 position-relative">
                      <span className="icon-addon">
                        <i className="isax isax-search-normal-1 fs-14"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Tìm kiếm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    {/* <div className="dropdown me-3">
                      <a
                        href="#"
                        className={`dropdown-toggle text-gray-6 btn rounded border d-inline-flex align-items-center ${
                          isTourTypeOpen ? "show" : ""
                        }`}
                        data-bs-toggle="dropdown"
                        aria-expanded={isTourTypeOpen ? "true" : "false"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTourTypeDropdown();
                        }}
                      >
                        {tourTypeText}
                      </a>
                      <ul
                        className={`dropdown-menu dropdown-menu-end p-3 ${
                          isTourTypeOpen ? "show" : ""
                        }`}
                        style={
                          isTourTypeOpen
                            ? {
                                position: "absolute",
                                inset: "0px -6px auto auto",
                                margin: "0px",
                                transform: "translate(0px, 35px)",
                                textAlign: "center",
                              }
                            : {}
                        }
                      >
                        <li>
                          <a
                            href="#"
                            className="dropdown-item rounded-1"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTourTypeChange("Tour Type");
                            }}
                          >
                            Tour Type
                          </a>
                        </li>
<li>
                          <a
                            href="#"
                            className="dropdown-item rounded-1"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTourTypeChange("Adventure Tourism");
                            }}
                          >
                            Adventure Tourism
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            className="dropdown-item rounded-1"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTourTypeChange("Escorted Tour");
                            }}
                          >
                            Escorted Tour
                          </a>
                        </li>
                        <li>
                          <a
                            href="#"
                            className="dropdown-item rounded-1"
                            onClick={(e) => {
                              e.preventDefault();
                              handleTourTypeChange("Ground Tour");
                            }}
                          >
                            Ground Tour
                          </a>
                        </li>
                      </ul>
                    </div> */}
                    <div className="dropdown me-3">
                      <a
                        href="#"
                        className={`dropdown-toggle text-gray-6 btn rounded border d-inline-flex align-items-center ${
                          isStatusOpen ? "show" : ""
                        }`}
                        data-bs-toggle="dropdown"
                        aria-expanded={isStatusOpen ? "true" : "false"}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleStatusDropdown();
                        }}
                      >
                        {statusText || "Trạng thái"}
                      </a>
                      <ul
                        className={`dropdown-menu dropdown-menu-end p-3 ${
                          isStatusOpen ? "show" : ""
                        }`}
                        style={
                          isStatusOpen
                            ? {
                                position: "absolute",
                                inset: "0px 0px auto auto",
                                margin: "0px",
                                transform: "translate(0px, 35px)",
                                textAlign: "center",
                              }
                            : {}
                        }
                      >
                        {[
                          "Status",
                          "Upcoming",
                          "Pending",
                          "Cancelled",
                          "Completed",
                        ].map((status) => (
                          <li key={status}>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleStatusChange(status);
                              }}
                            >
                              {console.log(status, "status")}
                              {status === "Status" ? "Trạng thái" : status}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    {/* <div className="d-flex align-items-center sort-by">
                      <span className="fs-14 text-gray-9 fw-medium">
                        Sort By :
                      </span>
                      <div className="dropdown me-3">
                        <a
                          href="#"
                          className={`dropdown-toggle text-gray-6 btn rounded d-inline-flex align-items-center ${
                            isRecommendedOpen ? "show" : ""
                          }`}
                          data-bs-toggle="dropdown"
                          aria-expanded={isRecommendedOpen ? "true" : "false"}
                          onClick={(e) => {
                            e.preventDefault();
                            toggleRecommendedDropdown();
                          }}
                        >
                          {sortByText}
                        </a>
                        <ul
                          className={`dropdown-menu dropdown-menu-end p-3 ${
                            isRecommendedOpen ? "show" : ""
                          }`}
                          style={
                            isRecommendedOpen
                              ? {
                                  position: "absolute",
                                  inset: "0px 0px auto auto",
                                  margin: "0px",
                                  transform: "translate(0px, 35px)",
                                  textAlign: "center",
                                }
                              : {}
                          }
                        >
                          <li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Recommend");
                              }}
                            >
                              Recommend
                            </a>
                          </li>
<li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Recently Added");
                              }}
                            >
                              Recently Added
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Ascending");
                              }}
                            >
                              Ascending
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Desending");
                              }}
                            >
                              Desending
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Last Month");
                              }}
                            >
                              Last Month
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              className="dropdown-item rounded-1"
                              onClick={(e) => {
                                e.preventDefault();
                                handleSortByChange("Last 7 Days");
                              }}
                            >
                              Last 7 Days
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </div>

                {/* <!-- Hotel List --> */}
                <div className="custom-datatable-filter table-responsive">
                  <table className="table datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>ID</th>
                        <th>Tour</th>
                        <th>Số lượng</th>
                        <th>Số ngày</th>
                        <th>Chi phí</th>
                        <th>Ngày khởi hành</th>
                        <th>Trạng thái</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookings &&
                        bookings.map((booking) => (
                          <tr key={booking.bookingId}>
                            <td>
                              <a
                                href="#"
                                className="link-primary fw-medium"
                                data-bs-toggle="modal"
                                data-bs-target="#upcoming"
                              >
                                #TR-{booking.bookingId}
                              </a>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <Link
                                  to={`/tour-detail/${booking.tourId}`}
                                  className="avatar avatar-lg"
                                >
                                  <img
                                    src="assets/img/tours/tours-20.jpg"
                                    className="img-fluid rounded-circle"
                                    alt="img"
                                  />
                                </Link>
                                <div className="ms-2">
                                  <p className="text-dark mb-0 fw-medium fs-14">
                                    <Link to={`/tour-detail/${booking.tourId}`}>
                                      {truncateText(booking.tourName, 5)}
                                    </Link>
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {booking.quantity}
                            </td>
                            <td>
                              {countDays(booking.startDate, booking.endDate)}{" "}
                              Ngày
                            </td>
                            <td>{formatPrice(booking.totalPrice)}</td>
                            <td>{formattedDateTime(booking.startDate)}</td>
                            <td>
                              <span
                                className={`badge ${statusBookingClassName(
                                  booking.status
                                )} rounded-pill d-inline-flex align-items-center fs-10`}
                              >
                                <i className="fa-solid fa-circle fs-5 me-1"></i>
                                {booking.status}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <a
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#upcoming"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedBooking(booking.bookingId);
                                    setShowModal(true);
                                  }}
                                >
                                  <i className="isax isax-eye"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                {/* <!-- /Hotel List --> */}
              </div>
            </div>
            {/* <!-- /Car-Booking List --> */}

            <div className="table-paginate d-flex justify-content-between align-items-center flex-wrap row-gap-3">
              <div className="value d-flex align-items-center">
                <span>Hiển thị</span>
                <select onChange={(e) => setPageSize(e.target.value)}>
                  <option value={2}>2</option>
                  <option selected value={5}>
                    5
                  </option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                </select>
                <span>tour đã đặt</span>
              </div>

              {totalPages > 0 && (
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    href="#"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <span className="me-3">
                      <i className="isax isax-arrow-left-2"></i>
                    </span>
                  </button>
                  <nav aria-label="Page navigation">
                    <ul className="paginations d-flex justify-content-center align-items-center">
                      {/* Render số trang */}
                      {Array.from({ length: totalPages }, (_, index) => (
                        <li key={index} className="page-item me-2">
                          <button
                            className={`page-link-1 d-flex justify-content-center align-items-center ${
                              currentPage === index + 1 ? "active" : ""
                            }`}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </nav>
                  <button
                    href="#"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <span className="ms-3">
                      <i className="isax isax-arrow-right-3"></i>
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
          {/* <!-- /Hotel Booking --> */}
        </div>
      </div>
      <BookingDetailModal
        show={showModal}
        onClose={() => setShowModal(false)}
        bookingId={selectedBooking}
        userInfo={userInfo}
        isCancelled={isCancelled}
        setIsCancelled={setIsCancelled}
      />
    </div>
  );
};

export default CustomerTourBooking;
